class SortDrawer extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.form.addEventListener('change', this.onSortChange.bind(this));
  }

  onSortChange(event) {
    const input = event.target;
    if (input.name !== 'sort_by') return;

    const grid = document.getElementById('product-grid');
    const container = document.getElementById('ProductGridContainer');
    if (!grid || !container) return;

    const sectionId = grid.dataset.id;
    const params = new URLSearchParams(window.location.search);
    params.set('sort_by', input.value);
    params.delete('page');

    const collectionElement = container.querySelector('.collection');
    if (collectionElement) collectionElement.classList.add('loading');

    const modal = this.closest('modal-dialog');
    if (modal && typeof modal.hide === 'function') modal.hide();

    const requestUrl = `${window.location.pathname}?section_id=${sectionId}&${params.toString()}`;

    fetch(requestUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const parsedHtml = new DOMParser().parseFromString(responseText, 'text/html');
        const newContainer = parsedHtml.getElementById('ProductGridContainer');
        if (newContainer) container.innerHTML = newContainer.innerHTML;

        history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
      })
      .catch(() => {})
      .finally(() => {
        if (collectionElement) collectionElement.classList.remove('loading');
      });
  }
}

customElements.define('sort-drawer', SortDrawer);
